import { Mail, Phone, MapPin, User } from 'lucide-react';
import PolicyLayout from '../components/PolicyLayout';

const ContactPage = () => (
  <PolicyLayout
    title="Contact Us"
    subtitle="mybook.rent — India's First Peer-to-Peer Book Rental Platform"
    updated="Last updated on March 2026"
    testId="contact-page"
  >
    <p>
      We&rsquo;re here to help with bookings, deposits, and any other questions about the platform.
      Reach us using the details below.
    </p>

    <div className="not-prose grid gap-4 sm:grid-cols-2 mt-6">
      <div className="rounded-xl border border-gray-200 bg-gray-50 p-5">
        <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">Merchant Legal Entity</p>
        <p className="font-semibold text-gray-900">BOOKONRENT</p>
      </div>
      <div className="rounded-xl border border-gray-200 bg-gray-50 p-5">
        <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">Platform Name</p>
        <p className="font-semibold text-gray-900">mybook.rent</p>
      </div>
      <div className="rounded-xl border border-gray-200 bg-gray-50 p-5 sm:col-span-2">
        <p className="text-xs uppercase tracking-wide text-gray-500 mb-2 flex items-center gap-1.5">
          <MapPin className="h-3.5 w-3.5" /> Registered &amp; Operational Address
        </p>
        <p className="font-medium text-gray-900">
          312, Incor Opulence, Gunjur Palya Road, Bengaluru, Karnataka – 560087
        </p>
      </div>
      <div className="rounded-xl border border-gray-200 bg-gray-50 p-5">
        <p className="text-xs uppercase tracking-wide text-gray-500 mb-2 flex items-center gap-1.5">
          <Phone className="h-3.5 w-3.5" /> Telephone / WhatsApp
        </p>
        <a
          href="https://wa.me/918660785749"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold hover:underline"
          style={{ color: 'var(--primary)' }}
          data-testid="contact-whatsapp"
        >
          +91 86607 85749
        </a>
      </div>
      <div className="rounded-xl border border-gray-200 bg-gray-50 p-5">
        <p className="text-xs uppercase tracking-wide text-gray-500 mb-2 flex items-center gap-1.5">
          <Mail className="h-3.5 w-3.5" /> E-Mail ID
        </p>
        <a
          href="mailto:support@mybook.rent"
          className="font-semibold hover:underline"
          style={{ color: 'var(--primary)' }}
          data-testid="contact-email"
        >
          support@mybook.rent
        </a>
      </div>
      <div className="rounded-xl border border-gray-200 bg-gray-50 p-5 sm:col-span-2">
        <p className="text-xs uppercase tracking-wide text-gray-500 mb-2 flex items-center gap-1.5">
          <User className="h-3.5 w-3.5" /> Grievance Officer
        </p>
        <p className="font-semibold text-gray-900">P. Kalyan Chaitanya, Founder</p>
      </div>
    </div>
  </PolicyLayout>
);

export default ContactPage;
